var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import { hangPromise } from "@irati/utils/promise";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { walletTracking } from "@irati-tracking/wallet";
import Loading from "@irati/ui/src/Loading";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import authentication from "@irati/auth";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import { WrappedLoader } from "./styled";
var NoDataCTA = /** @class */ (function (_super) {
    __extends(NoDataCTA, _super);
    function NoDataCTA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasLinkedCards: undefined,
            load: hangPromise()
        };
        _this.componentDidMount = function () {
            _this.setState({ load: _this.hasLinkedCards() });
        };
        _this.handleLinkCardClick = function () {
            walletTracking.clickLinkCard();
        };
        _this.hasLinkedCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ hasLinkedCards: linkedCards.length > 0 });
            });
        };
        return _this;
    }
    NoDataCTA.prototype.render = function () {
        var idNamespace = id("no-data", this.props);
        var _a = this.state, hasLinkedCards = _a.hasLinkedCards, load = _a.load;
        var apps = this.context.apps;
        if (!authentication.apps("platform.fidel")) {
            return null;
        }
        return (React.createElement(Loading, { load: load, Loader: function () { return React.createElement(WrappedLoader, null); } }, hasLinkedCards ? (React.createElement(ButtonRouterLink, { full: true, primary: true, large: true, marginTop: 2, to: "/perks/location", app: apps.SEARCH, id: id("button-browse-perks", idNamespace) },
            React.createElement(Icon, { icon: IconTypes.location, small: true, marginRight: 1 }),
            React.createElement(FormattedMessage, { id: "wallet.noData.BrowsePerksButton" }))) : (React.createElement(ButtonRouterLink, { full: true, primary: true, large: true, marginTop: 2, onClick: this.handleLinkCardClick, to: "/settings/linkedcards/add", app: apps.ACCOUNT, id: id("button-link-card", idNamespace) },
            React.createElement(FormattedMessage, { id: "wallet.noData.linkCardButton" })))));
    };
    NoDataCTA.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return NoDataCTA;
}(PureComponent));
export default injectIntl(NoDataCTA);
